<app-quill-editor
    [safeDisplay]="true"
    [emphasizeLinks]="emphasizeLinks"
    [readonly]="true"
    [disabled]="true"
    [hideToolbar]="true"
></app-quill-editor>
